import React from 'react';
import styled from 'styled-components';

export const Footer = () => {
  return (
    <Container>
        <a data-aos="zoom-in" data-aos-offset="0" data-aos-duration="1500" href="https://www.instagram.com/cafferestoran_kolektivmfs/" target='_blank'><i className="fa-brands fa-instagram"></i></a> {/* eslint-disable-line */}
        <p>Kolektiv MFS Copyright &copy; 2025, all rights reserved</p>
    </Container>
  )
}

const Container = styled.footer`
    width: 100%;
    text-align: center;
    margin-top: 3.5rem;
    background-image: linear-gradient(to bottom, transparent, #000);

    i{
        font-size: 2.75rem;
        color: #cd0f1a;
        padding-bottom: 1.25rem;
    }

    p{
        color: #fff;
        font-size: .6rem;
        font-family: "Roboto", sans-serif;
        padding: .6rem;
    }
`;
